import { createFileRoute } from '@tanstack/react-router'

import { BrandVoice, WizardStep } from '@/components/onboarding'
import {
  ADDRESS,
  ANSWERS,
  AVOID,
  EMOJI,
  PREVIEW_EMPTY,
  PREVIEW_FILLED,
} from '@/mocks/onboarding/hlas'

/** The filled state is the reward, so it has to be reviewable on its own. */
type HlasSearch = { stav?: 'vyplneno' }

export const Route = createFileRoute('/onboarding/hlas')({
  validateSearch: (search: Record<string, unknown>): HlasSearch =>
    search.stav === 'vyplneno' ? { stav: 'vyplneno' } : {},
  head: () => ({ meta: [{ title: 'Jak o vás psát · Aplikace Bitez' }] }),
  component: OnboardingHlas,
})

/**
 * Step 2 — the client's voice.
 *
 * It is in the wizard for the same reason the logo is not: **it is answerable
 * from memory.** A restaurateur knows instantly whether they say ty or vy, what
 * people come back for and what must never appear on their profile; none of it
 * needs a file, a password or a computer.
 *
 * Built around a **live caption preview**, the way step 1 is built around the
 * live venue card. Step 1 shows how they will look, this one shows how they
 * will sound — and a tone setting that only reads "tykáme · sem tam emoji" is a
 * preference nobody can picture.
 *
 * Nothing here is mandatory: the honest answer to "co nikdy nepublikovat" is
 * often "nic mě nenapadá", and Bára asks again once there is something to react
 * to.
 */
function OnboardingHlas() {
  const { stav } = Route.useSearch()
  const filled = stav === 'vyplneno'

  return (
    <WizardStep
      step={2}
      backHref="/onboarding/podnik"
      nextHref="/onboarding/foceni"
      note="Podle tohohle píše Bára vaše příspěvky. Kdykoliv to jde změnit."
      skip={filled ? undefined : { label: 'Nechám to na Báře', href: '/onboarding/foceni' }}
    >
      <BrandVoice
        address={ADDRESS}
        emoji={EMOJI}
        avoid={AVOID}
        preview={filled ? PREVIEW_FILLED : PREVIEW_EMPTY}
        answers={filled ? ANSWERS : undefined}
      />
    </WizardStep>
  )
}
